// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// Rxjs
import { tap } from 'rxjs/operators';
import { of } from 'rxjs';

// Helper
import { Extensions } from 'app/_helpers/Extensions';

// Environment
import { environment } from 'environments/environment';
import { SupplierModel } from 'app/_models/supplier.model';
import { AddSupplierModel } from 'app/_models/add-supplier.model';

@Injectable({
    providedIn: 'root',
})
export class MDMService {
   MDM_SERVER_URL: string = environment.apiProtocol + environment.Services.MasterDataURL;
   //MDM_SERVER_URL: string = "http://localhost:44335";
    countries: any;
    genders: any;
    alarmCenter: any;
    supplierType: any;
    supplierDossier: any;
    supplierAddress: any;
    constructor(private httpClient: HttpClient) { }
    private createCompleteRoute(route: string, envAddress: string) {
        return `${envAddress}/${route}`;
    }
     private generateHeaders(includeCache: boolean = false) {
        let headersConfig = {
            'Content-Type': 'application/json'
        };
        if (!includeCache) {
            headersConfig['Cache-Control'] = 'no-cache';

        }
        return {
            headers: new HttpHeaders(headersConfig)
        };
    }

    public getData(route: string,includeCache: boolean = false) {
        return this.httpClient.get(
            this.createCompleteRoute(route, this.MDM_SERVER_URL), this.generateHeaders(includeCache)
        );
    }

    getIagPartners() {
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetIAGPartners', this.generateHeaders(true));
    }

    getInsurers() {
        return this.httpClient.get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetInsurers', this.generateHeaders(true));
    }

    getCountries() {
        if (Extensions.isNull(this.countries)) {
            return this.httpClient
                .get(this.MDM_SERVER_URL + '/OData/Country?$orderby=name', this.generateHeaders())
                .pipe(tap((x) => (this.countries = x)));
        } else {
            return of(this.countries);
        }
    }

    getAccounts(){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/Account/Get', this.generateHeaders());
    }

    getActiveAccounts(){
        return this.httpClient.get(this.MDM_SERVER_URL + '/api/Account/GetActiveAccount', this.generateHeaders());
    }

    getAlarmcentersByCountry(countryCode){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetAlarmcentersByCountry/'+countryCode, this.generateHeaders());
    }
    getOrganizationByClient(travelInsurer){
        return this.httpClient
                .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetInsurersClientByOrganizationCodes',travelInsurer, this.generateHeaders());
    }
    getCostContainerByCountry(countryCode){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetCostContainerByCountry/'+countryCode, this.generateHeaders());
    }

    getIAGPartnerByCountry(countryCode){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetIAGPartnerByCountry/'+countryCode, this.generateHeaders());
    }

    getHealthInsuranceByInvolvedCoverageId(involvedCoverageId){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetHealthInsuranceByInvolvedCoverageId/'+involvedCoverageId, this.generateHeaders());
    }

    getTravelInsuranceByInvolvedCoverageId(involvedCoverageId){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetTravelInsuranceByInvolvedCoverageId/'+involvedCoverageId, this.generateHeaders());
    }

    getForeignAffairs(){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetForeignAffairs', this.generateHeaders());
    }

    getAccountById(accountId){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/Account/GetById/'+accountId, this.generateHeaders());
    }

    saveAccount(account){
        return this.httpClient
                .post(this.MDM_SERVER_URL + '/api/Account/Post',account , this.generateHeaders());
    }

    updateAccount(account){
        return this.httpClient
                .put(this.MDM_SERVER_URL + '/api/Account/Put',account , this.generateHeaders());
    }

    getOpenReservedActionsByUserId(userId){
        return this.httpClient.get(this.MDM_SERVER_URL + '/api/Account/GetOpenReservedActionsByUserId/'+userId , this.generateHeaders());
    }

    getGroupRoles(){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/AuthorizationGroupRole/Get', this.generateHeaders());
    }

    getRoles(){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/AuthorizationRole/Get', this.generateHeaders());
    }

    getRoleTypes(){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/AuthorizationRoleType/Get', this.generateHeaders());
    }

    getRoleById(id){
        return this.httpClient
                .post(this.MDM_SERVER_URL + '/api/AuthorizationRole/GetById/',{'Id':id}, this.generateHeaders());
    }

    addRole(role){
        return this.httpClient
                .post(this.MDM_SERVER_URL + '/api/AuthorizationRole/post/',role, this.generateHeaders());
    }

    updateRole(role){
        return this.httpClient
                .put(this.MDM_SERVER_URL + '/api/AuthorizationRole/put/',role, this.generateHeaders());
    }

    deleteGroupRole(id){
        return this.httpClient
                .delete(this.MDM_SERVER_URL + '/api/AuthorizationGroupRole/delete/'+id, this.generateHeaders());
    }

    getUserRoles(){
        return this.httpClient
                .get(this.MDM_SERVER_URL + '/api/AuthorizationRole/GetByEmail', this.generateHeaders());
    }

    getUserFunctionnalities(){

        return this.httpClient
        .get(environment.Authentication.authApiUrl + "roles", this.generateHeaders())
    }

    addRoleGroup(roleGroup){
        return this.httpClient
            .post(this.MDM_SERVER_URL + '/api/AuthorizationGroupRole/Post' ,roleGroup , this.generateHeaders());
    }

    updateRoleGroup(roleGroup){
        return this.httpClient
            .put(this.MDM_SERVER_URL + '/api/AuthorizationGroupRole/Put' ,roleGroup , this.generateHeaders());
    }

    updateAuthorizationRoleType(roleGroup){
        return this.httpClient
            .put(this.MDM_SERVER_URL + '/api/AuthorizationRole/PutAuthorizationRoleType' ,roleGroup , this.generateHeaders());
    }

    getGendres() {
        if (Extensions.isNull(this.genders)) {
            return this.httpClient
                .get(this.MDM_SERVER_URL + '/OData/Gender', this.generateHeaders())
                .pipe(tap((x) => (this.genders = x)));
        } else {
            return of(this.genders);
        }
    }
    GetSuppliersByPage(filter) {
        return this.httpClient
            .post(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetSuppliersByPage" , filter, this.generateHeaders());
    }
    getInsurerAlarmCenter(insurerId) {
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetInsurerAlarmCenters?InsurerId=' + insurerId, this.generateHeaders());
    }

    getSupplierType(supplierId) {
        return this.httpClient
            .get(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetSupplierType?supplierId=" + supplierId, this.generateHeaders())
            .pipe(tap((x) => (this.supplierType = x)));
    }

    getSupplierDossier(supplierId) {
        return this.httpClient
            .get(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetSupplierDossier?supplierId=" + supplierId, this.generateHeaders())
            .pipe(tap((x) => (this.supplierDossier = x)));
    }

    getSupplierAddress(supplierId) {
        return this.httpClient
            .get(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetSupplierAddress?supplierId=" + supplierId, this.generateHeaders())
            .pipe(tap((x) => (this.supplierAddress = x)));
    }

    getInsurerPhoneNumber(insurerId) {
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetInsurerPhoneNumber?insurerId=' + insurerId, this.generateHeaders());
    }

    getMandatesPhoneNumber(mandateId) {
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetMandatePhoneNumber?mandateId=' + mandateId, this.generateHeaders());
    }

    getSupplier(item:SupplierModel){
        return this.httpClient
            .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/SearchSuppliers' ,item , this.generateHeaders());
    }

    getSuppliersLocations(suppliersIds) {
        return this.httpClient
            .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetSuppliersLocations' , suppliersIds, this.generateHeaders());
    }

    addSupplier(item:AddSupplierModel){
        return this.httpClient
            .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/AddSupplier' ,item , this.generateHeaders());
    }

    updateSupplier(item:AddSupplierModel){
        return this.httpClient
            .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/UpdateSupplier' ,item , this.generateHeaders());
    }

    getOrganizationUnitByCode(ouCode){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetOrganizationUnitByCode?ouCode=' + ouCode, this.generateHeaders());
    }

    GetAllInsurerAlarmCenters() {
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetAllInsurerAlarmCenters', this.generateHeaders(true));
    }

    getActiveClients() {
        return this.httpClient.get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetActiveClients', this.generateHeaders(true));
    }

    getAllSupplierTypes() {
        return this.httpClient.get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetAllSupplierTypes', this.generateHeaders());
    }

    getRehospitalisationSupplierType(supplierId) {
        return this.httpClient
            .get(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetRehospitalisationSupplierType?supplierId=" + supplierId, this.generateHeaders())
            .pipe(tap((x) => (this.supplierType = x)));
    }

    getExecutorSupplierAdresses(correspondanceViewModel)
    {
        return this.httpClient
            .put(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetExecutorSupplierEmailAdresses",correspondanceViewModel, this.generateHeaders())
            .pipe(tap((x) => (this.supplierType = x)));
    }

    getContractedSupplierAdresses(correspondanceViewModel)
    {
        return this.httpClient
            .put(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetContractedSupplierEmailAddresses",correspondanceViewModel, this.generateHeaders())
            .pipe(tap((x) => (this.supplierType = x)));
    }
    getLocationSupplierEmailAdresses(correspondanceViewModel)
    {
        return this.httpClient
            .put(this.MDM_SERVER_URL + "/api/OrganizationUnit/getLocationSupplierEmailAdresses",correspondanceViewModel, this.generateHeaders())
            .pipe(tap((x) => (this.supplierType = x)));
    }

    getInsurancePoliciesAdresses(correspondanceViewModel)
    {
        return this.httpClient
            .put(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetInsurancePoliciesAdresses",correspondanceViewModel, this.generateHeaders())
            .pipe(tap((x) => (this.supplierType = x)));
    }


    getForeignAffairsAdresses(correspondanceViewModel)
    {
        return this.httpClient
            .put(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetForeignAffairsAdresses",correspondanceViewModel, this.generateHeaders())
            .pipe(tap((x) => (this.supplierType = x)));
    }

    GetSupplierInfo(supplierId)
    {
        return this.httpClient
        .get(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetSupplierInfo?supplierId=" + supplierId, this.generateHeaders())
    }

    getSupplierContacts(supplierId)
    {
        return this.httpClient.get(this.MDM_SERVER_URL + "/api/OrganizationUnit/GetSupplierContacts?supplierId=" + supplierId, this.generateHeaders());
    }

    CheckHealthMiscellanous(miscellanous){
        return this.httpClient
            .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/CheckHealthMiscellanous' ,miscellanous , this.generateHeaders());

    }
    CheckTravelMiscellanous(miscellanous){
        return this.httpClient
            .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/CheckTravelMiscellanous' ,miscellanous , this.generateHeaders());

    }
    getAllInsurersClientPiaByOrganizationCodes(travelInsurerList){
        return this.httpClient
            .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetAllInsurersClientPiaByOrganizationCodes' ,travelInsurerList , this.generateHeaders());
    }

    getOrganizationUnitCodeTypes(){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetOrganizationUnitCodeTypes', this.generateHeaders());
    }

    getOrganizationUnitById(organizationUnitId : string){
        return this.httpClient
        .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetOrganizationUnitById/'+organizationUnitId, this.generateHeaders());
    }

    getCodeTypesByOrganizationUnitId(organizationUnitId : string){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetOrganizationUnitCodeTypesByOrganizationUnitId/'+organizationUnitId, this.generateHeaders());
    }

    getMandateList(){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetMandates', this.generateHeaders());
    }

    getInsurerList(){
        return this.httpClient
        .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetInsurers', this.generateHeaders(true));
    }

    getClientsList(){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetInsurersClientsAndCoreIAGPartners', this.generateHeaders(true));
    }


    getOrganizationUnitByMandate(mandateNumber){
     return this.httpClient
        .get(this.MDM_SERVER_URL +'/api/OrganizationUnit/GetInsurersClientByMandateCode/'+ mandateNumber, this.generateHeaders())
    }
    getInsurerByUzoviCode(healthInsurance){
        return this.httpClient
                .post(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetInsurersClientByOrganizationCodeByUzoviCode',healthInsurance, this.generateHeaders());
    }

    getProductListByClient(ouId : string){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetInsurerProductList?insurerId='+ouId, this.generateHeaders());
    }

    getOrganizationUnitCoverageProductList(ouId : string){
        return this.httpClient
        .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetOrganizationUnitCoverageProductList?organizationUnitId='+ouId, this.generateHeaders());
    }

    getCoverageProductListByOrganizationUnitAndReferenceDate(ouId : string,referenceDate : string){
        return this.httpClient
        .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetCoverageProductListByOrganizationUnitAndReferenceDate'+'?organizationUnitId='+ouId+'&referenceDate='+ referenceDate, this.generateHeaders());
    }

    getCEDProductWorkActivityOptions(){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetCEDProductWorkActivityOptions', this.generateHeaders());
    }

    getCEDProductInactiveWorkActivityOptions(){
        return this.httpClient.get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetCEDProductInactiveWorkActivityOptions', this.generateHeaders());
    }

    getAllInsurersMandatesIAGPartners(){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetAllInsurersMandatesIAGPartners', this.generateHeaders());
    }

    getAllAlarmcenters(){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetAlarmcenters', this.generateHeaders(true));
    }

    getMandateAlarmCentersByMandateId(mandateId : string){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetMandateAlarmCentersByMandateId?mandateId='+mandateId, this.generateHeaders());
    }

    getAllInsurersMandatesAlarmCenters(){
        return this.httpClient
            .get(this.MDM_SERVER_URL + '/api/OrganizationUnit/GetAllInsurersMandatesAlarmCenters', this.generateHeaders());
    }
}